import BadgeTag from "./BadgeTags";

export default function OnlyText({
    title,
    tag = false,
    contentAlign = "left",
    cta = false,
    description = null,
    theme = "dark",
    badges = false,
    classNames,
    paragraph = null,
    hasOpenMarketBadge = false,
}) {
    return (
        <section
            className={`only-text component ${theme ? `--theme-${theme}` : ""} --content-${contentAlign} ${classNames || ""
                }`}
        >
            <div className="content">
                <div className="text-content">
                    <div className="inner-content-wrapper">
                        {tag && (
                            <div className="tag">
                                <img src={`${window._env_.STATIC_HOST}/static/website/images/icons/icon-arrow-left.svg`} alt="" />
                                {tag}
                                <img src={`${window._env_.STATIC_HOST}/static/website/images/icons/icon-arrow-right.svg`} alt="" />
                            </div>
                        )}

                        <h2 className="title-1 title">{title}</h2>

                        {description && (
                            <div className="long-text-content" dangerouslySetInnerHTML={{ __html: description }} />
                        )}

                        {paragraph && <p className="paragraph">{paragraph}</p>}
                    </div>

                    {badges && (
                        <div className="badges">
                            <BadgeTag
                                type={hasOpenMarketBadge ? "open-market" : "close-market"}
                                theme="light"
                                marketTag
                            />

                            <BadgeTag type="refresh" />
                        </div>
                    )}
                </div>

                {cta && (
                    <a href={cta.url} className="btn btn-primary" data-external-check-exempt>
                        {cta.text}
                    </a>
                )}
            </div>
        </section>
    );
}
